import _ from 'lodash'

class AuthInterceptor {
  constructor() {}

  static factory($q, $location, flash, $injector, appConfig) {
    return {
      'request': config => {
        const authService = $injector.get('AuthService')
        const $route = $injector.get('$route')
        if ($route.current && $route.current.$$route.auth &&
            _.includes(config.url, appConfig.microserviceDomain) &&
            !authService.loggedIn) {
          flash.setMessage("Your session has expired. Please log in to access the site.")
          const redirectUrl = $location.url()
          $location.url("/login?redirectTo=" + encodeURIComponent(redirectUrl))
        }
        return config
      }
    }
  }
}

AuthInterceptor.factory.$inject = ['$q', '$location', 'flash', '$injector', 'config']

export default AuthInterceptor

